import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useStateContext } from "../reducers";

function BaseContainer(props: any) {
    const {menuState} = useStateContext();
    const {children} = props;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    justifyContent: "start",
                    width: "100%",
                    overflowY: "auto",
                }}
            >
            {
                children
            }
            </Box>
        </>
    );
};

export default BaseContainer;
